<script>
import Vue from 'vue';
import Chatbox from '../../components/global/Chatbox'
import events from '../../events/events';
import shared from './../../pages/hours/shared';

export default
{
    name: 'ItemChatbox',

    extends: Chatbox,

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        placeholder()
        {
            return this.$t('page.hours.comment');
        },
    },

    methods:
    {
        getComments()
        {
            return shared.getComments(this.payload);
        },

        deleteComment(id)
        {
            this.$http.delete('/api/item/messages/' + id)
            .then(response =>
            {
                shared.removeComment(id);
                this.scrollToBottom();
            });
        },

        submitMessage(date)
        {
            if ( ! this.message) return;

            this.$http.post('/api/item/messages', {
                'item': this.payload,
                'message': this.message,
            })
            .then(response =>
            {
                this.message = '';
                this.shared.comments.push(response.data);
                this.scrollToBottom();

                // setTimeout(() => this.close(), 1000);
            });
        },

        close()
        {
            events.$emit('toolbox.close');
        }
    },
}
</script>



// WEBPACK FOOTER //
// ItemChatbox.vue?02c46b78